import $ from 'jquery';
import {smoothy} from "../Libraries/smoothy";


function closest($elem, selector) {
    let $closest = $elem.find(selector);
    while ($closest.length === 0 && $elem.length > 0) {
        $elem = $elem.parent();
        $closest = $elem.find(selector);
    }
    return $closest.first();
}


// currently only supports linking #ftn1 to #ftnref1 and vice versa
// optionally prefixed with a single "_"
$('a[href^="#_ftn"], a[href^="#ftn"]').each(function (i, elem) {
    let $link = $(elem);
    $link.addClass('no-scroll');

    let href = $link.attr('href');
    let m;
    let $other;
    if ((m = href.match(/^#_?ftn(\d+)$/))) {
        let d = m[1];
        $other = closest($link, `a[href="#_ftnref${d}"], a[href="#ftnref${d}"]`);
    } else if ((m = href.match(/^#_?ftnref(\d+)$/))) {
        let d = m[1];
        $other = closest($link, `a[href="#_ftn${d}"], a[href="#ftn${d}"]`);
    } else {
        return;
    }

    $link.on('click', ev => {
        ev.preventDefault();
        smoothy(() => $other.offset().top - $(window).height() * 0.3, 1000);
        setTimeout(() => {
            const $p = $other.closest('p, div');

            $p.removeClass('footnote-open');
            if ($p.data('ftnTimeoutHandle')) {
                clearTimeout($p.data('ftnTimeoutHandle'));
            }

            setTimeout(() => {
                $p.addClass('footnote-open');
                const handle = setTimeout(() => {
                    $p.removeClass('footnote-open');
                    clearTimeout($p.data('ftnTimeoutHandle'));
                    $p.data('ftnTimeoutHandle', null);
                }, 3000);

                $p.data('ftnTimeoutHandle', handle);
            }, 0);
        }, 300);
    });


});
